// START IMPORTS

import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';
import { useContext } from 'react';

import { DeepSearchContext } from '../../../context';

import { ArrowIcon, StepRow } from './components';

import type { SuggestedNextStepsData } from '../../../types';

interface SuggestedNextStepsCardProps {
  data: SuggestedNextStepsData;
}

export const SuggestedNextStepsCard = ({
  data,
}: SuggestedNextStepsCardProps) => {
  const { sendMessage } = useContext(DeepSearchContext);
  if (!data.steps.length) {
    return null;
  }
  const handleStepActivate = (step: string) => {
    sendMessage(step);
  };

  return (
    <Box px={2} py={1.5}>
      <Text variant="body1" fontWeight={700} mb={1}>
        Next steps:
      </Text>
      {data.steps.map((step, i) => (
        <StepRow
          key={i}
          onClick={() => handleStepActivate(step)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleStepActivate(step);
            }
          }}
          role="button"
          tabIndex={0}
        >
          <Stack height={24} width={24}>
            <ArrowIcon className="followup-arrow" />
          </Stack>
          <Text variant="body1">{step}</Text>
        </StepRow>
      ))}
    </Box>
  );
};
